<template>
  <div>
    <v-dialog
      v-if="isCurrentUser"
      v-model="dialog"
      persistent
      max-width="1000px"
    >
      <material-card
        :offset="10"
        :full-width="true"
        color="green"
        title="Announcements"
        text="Unread announcements"
        class="mb-0"
      >
        <v-container fluid>
          <v-row>
            <v-col cols="12">
              <v-data-table
                :headers="headers"
                :items="announcements"
                item-key="id"
                hide-default-footer
              >
                <template v-slot:item.title="{ item }">
                  <div>
                    <a
                      style="color:black"
                      class="font-weight-bold"
                      @click="loadAnnouncement(item.id)"
                    >
                      {{ item.title }}  
                    </a>
                  </div>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-container>
        
        <v-card-actions>
          <v-spacer />
          <v-btn
            text
            @click="dialog = false"
          >
            Close
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <v-skeleton-loader
      :loading="skeleton"
      class="mx-auto my-5"
      type="card"
    >
      <viewer 
        ref="viewer"
        :images="images"   
        :options="viewerOptions" 
        @inited="imageViewerInited"            
      >
        <template slot-scope="scope">
          <img 
            v-for="src in scope.images"
            v-show="false"             
            :key="src" 
            :src="src"
          >
        </template>
      </viewer>
      <material-card class="v-card-profile"> 
        <v-avatar
          slot="offset"  
          v-ripple
          class="mx-auto d-block cursor-pointer"     
          size="130"            
        >
          <img
            v-if="!avatar"
            :src="thumbnailUrl"
            onerror="this.src='img/thumbnail.jpg'"
            @click="showViewer"
          >
          <v-img
            v-else
            :src="avatar.imageURL"
          />            
        </v-avatar>                        
        <v-slide-x-transition>
          <div 
            v-if="avatar && saved == false"
            class="text-center"
          >         
            <v-btn 
              :disabled="saving"
              text
              icon
              @click="avatar = null"
            >
              <v-icon size="30">
                mdi-close-circle-outline
              </v-icon>
            </v-btn>     
            <v-btn 
              :loading="saving"
              text
              icon
              color="primary"
              @click="uploadImage"
            >
              <v-icon size="30">
                mdi-cloud-upload
              </v-icon>
            </v-btn>
          </div>
        </v-slide-x-transition>
        <v-card-text class="text-center">
          <h4 class="font-weight-bold">
            {{ name }}
          </h4>
          <p 
            v-if="departments" 
            class="font-weight-medium"
          >
            {{ departments }} 
          </p>
        </v-card-text>
      </material-card>
    </v-skeleton-loader>      
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  export default {
    components: {
    },
    props: {
      userUid: {
        type: String,
        default: '',
      },
      employeeUid: {
        type: String,
        default: '',
      },
      personUid: {
        type: String,
        default: '',
      },
    },
    data () {
      return {
        dialog: false,
        announcements: [],
        headers: [
          {
            text: 'Announcement Title',
            align: 'left',
            value: 'title',
            sortable: false,
          },
          {
            text: 'Announcement Date',
            align: 'center',
            value: 'announcement_date',
            sortable: false,

          },
          {
            text: 'Announcement By',
            align: 'center',
            value: 'created_by',
            sortable: false,
          },
        ],

        user: {},
        person: {},
        employee: {},
        employeePosition: {},
        skills: [],
        requirements: [],
        employeeAward: [],
        department: {},
      
        viewerOptions: {       
          navbar: 0,
          movable: 0,
          rotatable: 0,
          title: 3,
        
          toolbar: {
            zoomIn: 2,
            zoomOut: 2,
            reset: 2,
            play: {
              show: 2,
              size: 'large',
            },

            oneToOne: 0,
            prev: 0,
            next: 0,
            rotateLeft: 0,
            rotateRight: 0,
            flipHorizontal: 0,
            flipVertical: 0,
          },
        },
        avatar: null,
        defaultAvatar: 'img/thumbnail.jpg',
        saving: false,
        saved: false,
        skeleton: true,
      }
    },
    computed: {
      ...mapState('lookup', ['place_of_birth']),
      ...mapState({ isCurrentUser: 'isMyProfile' }),
      images () {
        return [ this.avatarUrl ]
      },
      avatarUrl () {
        return this.employee.avatar_url
      },
      departments () {
        return this.department.name
      },
      thumbnailUrl () {
        return this.employee.thumbnail_url || this.defaultAvatar
      },
      name () {
        return this.person.name || 'Name'
      },
      placeOfBirth () {
        return (this.place_of_birth.find(placeOfBirth => {
          return placeOfBirth.lookup_uid === this.person.dob_state_lookup_uid 
        }) || {}).value || 'Sarawak'
      },
    },
    watch: {
      avatar: {
        handler (newValue) {
          this.saved = false
        },
        deep: true,
      },
      employeeUid: {
        immediate: true,
        handler (value) {
          if (value) {
            this.$resetData()
            this.loadEmployee()
            this.loadEmployeePosition()
            this.loadEmployeeSkills()
            this.loadAnnouncementEmployees()
          }
        },
      },
      personUid: {
        immediate: true,
        handler (value) {
          if (value) {
            this.loadPerson()
          }
        },
      },
    },
    methods: {      
      uploadImage () {
        this.saving = true

        this.$api.employees().uploadAvatar(this.employeeUid, this.avatar.formData)
          .then(res => {
            if (res.status >= 200 && res.status < 300) {   
              if (this.isCurrentUser) {
                this.$store.dispatch('getCurrentUser')
              }
              this.loadEmployee()
              this.savedAvatar()  
            }          
          })
          .catch(() => {
            this.saving = false
            this.$snack({
              color: 'error',
              message: 'Photo upload failed, please try again',
            })
          }) 
      },
      loadEmployee () {
        this.$api.employees().show(this.employeeUid)
          .then(response => {
            this.employee = response.data
            if (this.employee.department_id) {
              this.$api.departments().show(this.employee.department_id)
                .then(response => {
                  this.department = response.data
                  this.skeleton = false
                })
            }
          })
      },
      loadEmployeeAward () {
        this.$api.employeeAwards().show(this.employeeUid)
          .then(response => {
            this.employeeAward = response.data
          })
      },    
      loadEmployeePosition () {
        this.$api.employeePositions().show(this.employeeUid)
          .then(response => {
            this.employeePosition = response.data
          })
      },
      loadEmployeeSkills () {
        this.$api.employeeSkills().list(this.employeeUid)
          .then(response => {
            this.skills = response.data
          })
      },
      loadPerson () {
        this.$api.persons().show(this.personUid)
          .then(response => {
            this.person = response.data
            this.skeleton = false
          })
      },
      loadAnnouncementEmployees () {
        this.$api.employeeAnnouncements().list('false')
          .then(response => {
            this.announcements = _.orderBy(response.data, ['created_at'], ['desc'])  
            if (this.announcements.length > 0) {
              this.dialog = true
            }
          })
      }, 
      loadAnnouncement (id) {
        this.$api.announcements().show(id)
          .then(announcement => {
            if (announcement.data && !announcement.data.acknowledgement_required) {
              this.$api.employeeAnnouncements().markAsRead(id)
                .then(res => {
                  this.$router.push({ path: '/announcements/' + id })
                })
            } else {
              this.$router.push({ path: '/announcements/' + id })
            }
          })
      },
      groupJobDescriptions (requirements) {
        return requirements.reduce((accumulator, requirement) => {
          let index = accumulator.findIndex(item => item.job_requirement.job_description_id === requirement.job_requirement.job_description_id)
        
          let requirementCopy = { ...requirement }
          let skillLevel = { ...requirementCopy.skill_level }
        
          delete requirementCopy.skill_level
          delete requirementCopy.skill_level_id

          if (index === -1) {
            accumulator.push({ ...requirementCopy, skill_levels: [ { ...skillLevel, position_job_requirement_id: requirement.id } ] })
          } else {
            accumulator[index].skill_levels.push({ ...skillLevel, position_job_requirement_id: requirement.id })
          }

          return accumulator
        }, [])
      },
      savedAvatar () {
        this.avatar = null
        this.saving = false
        this.saved = true
        this.$snack({
          message: 'Photo uploaded successfully!',
        })
      },
      imageViewerInited (viewer) {
        this.$viewer = viewer
      },
      showViewer () {
        this.$viewer.show()
      },
      scrollLeft () {
        if (this.$vuetify.breakpoint.smAndDown) document.querySelector('.wrapper-box-xs').scrollLeft -= 200
        else if (this.$vuetify.breakpoint.mdOnly)document.querySelector('.wrapper-box-md').scrollLeft -= 200
        else if (this.$vuetify.breakpoint.lgOnly)document.querySelector('.wrapper-box-lg').scrollLeft -= 200
        else document.querySelector('.wrapper-box').scrollLeft -= 200
      },
      scrollRight () {
        if (this.$vuetify.breakpoint.smAndDown) document.querySelector('.wrapper-box-xs').scrollLeft += 200
        else if (this.$vuetify.breakpoint.mdOnly)document.querySelector('.wrapper-box-md').scrollLeft -= 200
        else if (this.$vuetify.breakpoint.lgOnly)document.querySelector('.wrapper-box-lg').scrollLeft += 200
        else document.querySelector('.wrapper-box').scrollLeft += 200
      },
    },
  }
</script>
<style scoped>
.award-box {
  align-items:center;
  height:45px;
}
.wrapper-box {
  width:21vw;
  overflow-x: hidden;
  overflow-y: hidden;
}
.wrapper-box-lg {
  width:18vw;
  overflow-x: hidden;
  overflow-y: hidden;
}
.wrapper-box-md {
  width:21vw;
  overflow-x: hidden;
  overflow-y: hidden;
}
.wrapper-box-xs {
  width:72vw;
  overflow-x: hidden;
  overflow-y: hidden;
}
.wrapper-box::-webkit-scrollbar {
    display: none;
}

.profile-card-action img {
  box-shadow: none;
}

.cursor-pointer{
  cursor: pointer;
}
</style>
